import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

// Progression popup
class ProgressionPopup extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="progression-popup-component">
        <Popup open={this.props.modalOpened} modal={true} closeOnDocumentClick={false} closeOnEscape={false}>
          <div className="card">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="alc-staff-inner post__meta-block posts__item--card posts__item">
                    <header className="alc-staff__header">
                      <h1 className="page-heading__title">
                        <span className="alc-staff__header-last-name">
                          {this.props.popupTitle}
                        </span>
                      </h1>
                      <span className="alc-staff__header-role">
                        <h5 className="alc-staff__header-role-item">
                          Check progression status
                        </h5>
                      </span>
                    </header>
                    <h5>{this.props.progressMessage}</h5>
                    <button className="btn btn-ksmgallery" disabled={!this.props.allowModalClose}
                      onClick={() => { this.props.closePopup() }}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div>
    )
  }
}

export default ProgressionPopup;